import swal from "sweetalert2";

export async function confirmUnsavedChanges() {
	try {
		const result = await swal.fire({
			title: "Unsaved Changes",
			html: "<p>You have unsaved changes that will be lost. Are you sure you want to continue?</p>",
			showCloseButton: true,
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Confirm",
			focusCancel: true
		});

		return !result.dismiss;
	}
	catch(error) {
		return false;
	}
}
